import {
  MeetingRoomRounded,
  SnoozeRounded,
  DriveEtaRounded,
  DirectionsBikeRounded,
  EvStationRounded,
  AirplayRounded,
  AddToQueueRounded,
  LocalParkingRounded,
  MoreRounded,
} from '@mui/icons-material';
import React from 'react';
import { FacilityTypeEnum } from '../enums/facility-type';

const getIconFromFacilityTypeEnum = (facilityType: FacilityTypeEnum): React.JSX.Element => {
  switch (facilityType) {
    case FacilityTypeEnum.beamer:
      return <AirplayRounded />;
    case FacilityTypeEnum.bicycle:
      return <DirectionsBikeRounded />;
    case FacilityTypeEnum.car:
      return <DriveEtaRounded />;
    case FacilityTypeEnum.chargingStation:
      return <EvStationRounded />;
    case FacilityTypeEnum.display:
      return <AddToQueueRounded />;
    case FacilityTypeEnum.meetingRoom:
      return <MeetingRoomRounded />;
    case FacilityTypeEnum.parking:
      return <LocalParkingRounded />;
    case FacilityTypeEnum.silenceSpace:
      return <SnoozeRounded />;
    default:
      return <MoreRounded />;
  }
};

export default getIconFromFacilityTypeEnum;
